module.exports = { 
      attributes: {"title":"Erstes Hisshi","date":"2019-09-02T00:00:00.000Z","author":"Richi","categories":["hisshi"],"tags":["hisshi","easy"],"language":"de","imageUrl":"/hisshi/hisshi_0001.png","section":"Hisshi"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Wie muss der Spielstein abgelegt werden,\ndamit der Gegner anschließend nicht mehr verteidigen kann?")]),_vm._v(" "),_c('image-reel',[_vm._v("\nHisshi 1|/hisshi/hisshi_0001.png\n")]),_vm._v(" "),_c('details',[_c('summary',[_vm._v("Lösung")]),_vm._v("\n  S*43, mit diesem Drop kann der gegnerische Spieler nicht mehr verteidigen.\n  "),_c('image-reel',[_vm._v("\n  Lösung|/hisshi/hisshi_0001-1.png\n  ")])],1)],1) };
            this.$options.staticRenderFns = [];
          }
        }
      },
     }